import React from "react";
import "./Player.css";

import SideBar from "./SideBar/SideBar";
import Body from "./Body/Body";
import Footer from "./Footer/Footer";

function Player({ spotify }) {
  return (
    <div className="player">
      <div className="player_body">
        {/* SideBar  */}
        <SideBar />
        {/* Body */}
        <Body spotify={spotify}/>
      </div>
      {/* Footer */}
      <Footer/>
    </div>
  );
}

export default Player;
